import axios from "../utils/axios";

export const getDashboardStatsApi =
  () => {
    return axios.get(
      "/api/admin/dashboard",
      {
        withCredentials: true,
      }
    );
  };